import { Popconfirm, Select } from "antd";
import { Option } from "antd/es/mentions";
import React, { useEffect, useState } from "react";
import ClientLogsTab from "./ClientLogsTab";
import {
  createPatch,
  getProjectInfoById,
  listPatchVersion,
  trainModelWithPatch,
} from "../../../../../api/apiCallManager";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useSelectedServerVersionStore from "../../../../../components/hooks/useSelectedServerVersionStore";
import useProjectInfoQuery from "../../../../../components/hooks/useProjectInfoQuery";
import { useParams } from "react-router-dom";
import { showError, showSuccess } from "../../../../../helpers/alerts";
import confirm from "antd/es/modal/confirm";
import axios from "axios";
import useInfraFormData from "../../../../../components/hooks/useInfraFormData";
import ModelResult from "./ModelResult";
import { selectedServerVersionEdaTableDataStore } from "../../../../../zustand/store/selectedServerVersionEdaTableDataStore";
import AccessTo from "../../../../../components/is-show/AccessTo";
import { FL } from "../../../../router/AddRoutesJson";

function TrainLogs() {
  const [selectedValue, setSelectedValue] = useState("client");
  const [selectedPatch, setSelectedPatch] = useState("");
  const [serverProgressData, setServerProgressData] = useState([]);
  const [isTrainingStarted, setIsTrainingStarted] = useState(false);

  const {
    selectedServerVersionZustandState,
    setSelectedServerVersionZustandState,
  } = useSelectedServerVersionStore();
  const { id } = useParams();
  const {
    data: projectInfoData,
    error,
    isLoading,
  } = useProjectInfoQuery(id, getProjectInfoById);

  const handleClientServerChange = (value) => {
    setSelectedValue(value);
    console.log("Selected value:", value); // Logs the selected value
  };
  const queryClient = useQueryClient();

  const createPatchMutation = useMutation({
    mutationFn: createPatch,
    onSuccess: (data) => {
      if (data.statusCode == 200) {
        queryClient.invalidateQueries({ queryKey: ["listPatchVersion_"] }); // Invalidates all queries starting with 'todos'
        showSuccess("Patch Created Successfully");
      }
    },
  });

  const handleCreatePatch = () => {
    if (selectedServerVersionZustandState) {
      createPatchMutation.mutate({
        selectedServerVersionZustandState,
        projectKey: projectInfoData.project_key, // Replace with your project key
        version: selectedServerVersionZustandState,
      });
    } else {
      showError("Please select a Server Version");
    }
  };

  const {
    data: listPatchVersionData, // Renamed for better clarity
    isPending: isListPatchVersionLoading,
  } = useQuery({
    queryKey: ["listPatchVersion_", selectedServerVersionZustandState], // Unique query key
    queryFn: () =>
      listPatchVersion(
        projectInfoData.project_key,
        selectedServerVersionZustandState
      ),
  });

  const confirm = (e) => {
    handleCreatePatch();
  };
  // const fetchServerProgress = async () => {
  //   try {
  //     const response = await axios.get(
  //       `https://lexhue53xg.execute-api.ap-southeast-1.amazonaws.com/prod/server-progres?event_type=get_select_server_version&projectKey=Testing_entire_flow_for_creating_server_version&version=${selectedServerVersionZustandState}`
  //     );
  //     // if (response?.data?.statusCode == 200) {

  //     setServerProgressData(response?.data || []);
  //     // }
  //   } catch (error) {}
  // };

  // useEffect(() => {
  //   fetchServerProgress();
  // }, [selectedServerVersionZustandState]);
  // const clientNames = serverProgressData.map((item) => item.client_name);

  const {
    data: infraFormData,
    error: infraFormError,
    isLoading: infraFormLoading,
  } = useInfraFormData(id);

  const allFormattedTable = infraFormData?.map((client) => ({
    // infra: client.infra,
    clientName: client.clientName,
    // clientManager: client?.clientManager,
    // project_key: client?.infra[0]?.project_key,
    instanceName: client.name,
    // siteManager: client?.siteManager,
  }));
  const formattedData = {
    projectKey: projectInfoData?.project_key,
    clients: allFormattedTable?.filter((item) => item.clientName !== ""),
    server: allFormattedTable?.filter((item) => item.clientName === ""),
    event_type: "model_train",
    patch_version: selectedPatch,
  };

  const trainModelMutation = useMutation({
    mutationFn: trainModelWithPatch,
    onSuccess: (data) => {
      if (data.statusCode === 200) {
        showSuccess("Model Training Started Successfully");
        setIsTrainingStarted(true); // Disable button after successful response
      }
    },
    onError: (error) => {
      showError("Error starting model training");
    },
  });

  const handleTrainModel = () => {
    if (!selectedPatch) {
      showError("Please select a patch version before training the model");
      return;
    }
    trainModelMutation.mutate(formattedData);
  };
  const {
    selectedServerVersionEdaTableDataZustandState,
    setSelectedServerVersionEdaTableData,
  } = selectedServerVersionEdaTableDataStore();
  return (
    <div>
      {/* {JSON.stringify(formattedData)} */}
      <div>
        Patch Version
        <Select
          allowClear
          value={selectedPatch}
          onChange={(value) => {
            setSelectedPatch(value);
            setIsTrainingStarted(false); // Reset training state when patch changes
          }}
          loading={isListPatchVersionLoading}
          className="w-[170px] mx-1 lowercase"
          placeholder="Patch Version"
          dropdownRender={(menu) => (
            <>
              {menu}
              <div className="flex justify-center">
                <AccessTo role={[FL]}>
                  <Popconfirm
                    title="Create Patch"
                    description="Are you sure you want to create a patch?"
                    onConfirm={confirm}
                    okText="Yes"
                    cancelText="No"
                  >
                    <button
                      className="bg-yellow-500 w-[100%] m-2 py-1 text-[14px] rounded-sm px-4"
                      disabled={createPatchMutation.isPending} // Disable button while mutation is in progress
                    >
                      Create Patch
                    </button>
                  </Popconfirm>
                </AccessTo>
              </div>
            </>
          )}
        >
          {listPatchVersionData?.map((patch) => (
            <Option key={patch} value={patch}>
              {patch}
            </Option>
          ))}
        </Select>
        {/* {JSON.stringify(selectedServerVersionEdaTableDataZustandState[0]?.projectStatus)} */}
        <ModelResult
          selectedPatch={selectedPatch}
          trainModelBtn={
            selectedServerVersionEdaTableDataZustandState[0]?.projectStatus ==
            "approved" ? (
              <AccessTo role={[FL]}>
                <button
                  disabled={trainModelMutation.isPending || isTrainingStarted}
                  className=" bg-green-400 py-1 text-[14px] rounded-sm px-4 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleTrainModel}
                >
                  {trainModelMutation.isPending
                    ? "Training..."
                    : isTrainingStarted
                    ? "Training Started"
                    : "Train Model"}
                </button>
              </AccessTo>
            ) : (
              ""
            )
          }
        />
      </div>
      <div className="my-3">
        {/* <Select
          className="w-[170px] mx-1"
          placeholder=""
          defaultValue={"client"}
          onChange={handleClientServerChange}
        >
          <Option value="client">Client</Option>
          <Option value="server">Server</Option>
        </Select> */}
      </div>
      <div className="bg-[#efefef] p-5  block">
        {selectedValue == "client" ? (
          <ClientLogsTab
            selectedPatch={selectedPatch}
            clientsData={formattedData}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default TrainLogs;
